import React from "react"
import styled from "@emotion/styled"
import ReactHtmlParser from "react-html-parser"
import { colors } from "../../../styles/colors"
import { fontSize } from "../../../styles/fonts/fontStyle"
import { deviceMinW } from "../../../styles/mediaQueries"

const SideText = ({ copy }) => {
    return (
        <>
            <aside>
                <Text>{ReactHtmlParser(copy)}</Text>
            </aside>
        </>
    )
}
export default SideText

const Text = styled.p`
    font-size: ${fontSize.brevier};
    color: ${colors.silver};
    width: 100%;

    @media ${deviceMinW.mobileXL} {
        font-size: ${fontSize.longPrimer};
    }
    @media ${deviceMinW.tablet} {
        max-width: 20rem;
        font-size: ${fontSize.pica};
    }
`
